import React from 'react';
import classNames from 'classnames';
import {ReactTooltip} from "../../../core/components/tooltips/ReactTooltip";

export type ProgressBarSegment = {
    percentage: number; // Width of the segment as a percentage
    color: string; // Background color of the segment
    className?: string; // Optional additional class for styling
    title: string; // Value for progress bar tooltip
};

type ProgressBarProps = {
    segments: ProgressBarSegment[];
    tooltipId: string;
};

const ProgressBar = ({segments, tooltipId}: ProgressBarProps) => {
    let cumulativeWidth = 0;
    const firstIndexWithAnyValue = segments.findIndex((segment) => segment.percentage > 0);
    const lastIndexWithAnyValue = segments.length - 1 - [...segments].reverse().findIndex((segment) => segment.percentage > 0);

    return (
        <div id={tooltipId} className="progress-bar-container-table">
            {segments.map((segment, index) => {
                const segmentStyle = {
                    width: `${segment.percentage}%`,
                    left: `${cumulativeWidth}%`,
                };
                cumulativeWidth += segment.percentage;
                return (
                    <div key={index}
                         className={classNames(segment.className,
                             firstIndexWithAnyValue === index && 'left-radius-progress-bar-table',
                             lastIndexWithAnyValue === index && 'right-radius-progress-bar-table',
                             (firstIndexWithAnyValue !== index && lastIndexWithAnyValue !== index) && 'no-radius-progress-bar-table',
                         )}
                         style={segmentStyle}
                    ></div>
                );
            })}
            <ReactTooltip selectId={tooltipId} place="top">
                {segments.map((segment, index) => {
                    return (
                        <div className={"flex-container-row"}>
                            <div className={classNames("legend-square", segment.className)}></div>
                            <div
                                className={classNames("flex-align-l padding-left-s padding-right-s d-flex align-self-start", index !== segments.length - 1 && "margin-bottom-s")}>
                                {segment.title}
                            </div>
                            <div className={classNames("subtle margin-left-m")}>{segment.percentage.toFixed(0)}%</div>
                        </div>
                    );
                })}
            </ReactTooltip>
        </div>
    );
};

export default ProgressBar;
